import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,311.855529 C1849.29882,345.624941 1773.40235,368.326118 1693.77882,378.716706 C1775.09647,326.199059 1837.55294,243.187294 1867.03059,144.024941 C1790.79529,192.702588 1706.31529,228.053176 1616.64,247.027294 C1544.92235,164.467294 1442.37176,112.966118 1329.20471,112.966118 C1111.45412,112.966118 935.04,302.933176 935.04,537.173176 C935.04,570.490824 938.654118,602.792 945.204706,633.850824 C617.901176,616.119059 327.303529,447.384941 133.044706,190.669647 C99.2752941,253.239059 79.7364706,326.199059 79.7364706,403.902588 C79.7364706,551.064941 170.767059,680.721412 276.48,756.956706 C211.877647,754.697882 119.378824,735.497882 119.378824,703.648471 L119.378824,709.295529 C119.378824,914.622588 233.788235,1085.95435 413.929412,1125.14494 C380.950588,1134.632 335.548235,1139.94024 299.52,1139.94024 C274.108235,1139.94024 244.065882,1137.22965 219.896471,1132.14729 C270.155294,1300.65553 413.025882,1423.30965 585.374118,1426.92376 C450.522353,1540.42965 279.303529,1608.30729 94.7576471,1608.30729 C62.9082353,1608.30729 30.72,1606.27435 0,1602.43435 C174.494118,1722.60376 381.176471,1792.96612 603.670588,1792.96612 C1328.64,1792.96612 1724.72471,1146.82965 1724.72471,586.415529 C1724.72471,568.006118 1724.27294,549.483765 1723.36941,531.300235 C1800.39529,471.554353 1867.25647,396.900235 1920,311.855529",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTwitterBoxedSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTwitterBoxedSolid, _Component);

  var _super = _createSuper(IconTwitterBoxedSolid);

  function IconTwitterBoxedSolid() {
    _classCallCheck(this, IconTwitterBoxedSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTwitterBoxedSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('<IconTwitterBoxedSolid /> is deprecated. Please use <IconTwitterSolid /> instead.');
      }

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTwitterBoxed",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTwitterBoxedSolid.displayName = "IconTwitterBoxedSolid";
  return IconTwitterBoxedSolid;
}(Component);

IconTwitterBoxedSolid.glyphName = 'twitter-boxed';
IconTwitterBoxedSolid.variant = 'Solid';
IconTwitterBoxedSolid.deprecated = true;
IconTwitterBoxedSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTwitterBoxedSolid;
export { IconTwitterBoxedSolid };